export default __webpack_public_path__ + "static/thumb-landscape-5f7b20b10680c1ebf688f58d02268571.jpg";